import React, {FC, memo} from 'react';
import './App.css';
import {Persistor} from "redux-persist/es/types";
import {PersistGate} from "redux-persist/integration/react";
import {Provider} from "react-redux";
import {Store} from "@reduxjs/toolkit";
import RoutNavigation from "./RoutNavigation";
import Modals from "./modal/Modals";
import {Spinner} from "react-bootstrap";
import Loading from "./component/loading/Loading";
import ProgressBarView from "./component/progressBar/ProgressBarView";
import ContextBackground from "./component/contextBackground/ContextBackground";

interface IApp {
    store: Store;
    persistor: Persistor;
}

const App: FC<IApp> = ({store, persistor}) => (
    <Provider store={store}>
        <PersistGate loading={<div><Spinner variant={"primary"}/></div>} persistor={persistor}>
            <RoutNavigation/>
            <Modals/>
            <Loading/>
            <ProgressBarView/>
            <ContextBackground/>
        </PersistGate>
    </Provider>
)

export default memo(App);
